import React, {useContext, useEffect} from 'react';

import {StoreContext} from './root-store';

import '../../../patterns/components/icon/icon/icons';
import {MobxRouter, startRouter} from 'mobx-router';
import {routes} from './routes';


export const AppRouter = (): JSX.Element => {
    const store = useContext(StoreContext);

    useEffect(() => {
        const azureRedirectCall = async ():Promise<void> => {
            await store.azureSsoStore.handleMsalRedirectPromise();
            startRouter(routes, store);
        };

        azureRedirectCall();
    }, []);

    return (
        <MobxRouter store={store}/>
    );
};
